(() => {
  const COLOR_FILE_PATTERN = /\/dynapos-c-([A-Za-z0-9_-]+?)-/i;
  const HIDDEN_CLASS = 'dynapos-color-media--hidden';

  const normalize = (value) => String(value || '').trim().toLocaleLowerCase();

  function decodeColor(token) {
    try {
      const base64 = token.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(token.length / 4) * 4, '=');
      const bytes = Uint8Array.from(atob(base64), (character) => character.charCodeAt(0));
      return new TextDecoder().decode(bytes);
    } catch (_error) {
      return '';
    }
  }

  function imageColor(image) {
    const source = image.currentSrc || image.getAttribute('src') || image.getAttribute('srcset') || '';
    const match = source.match(COLOR_FILE_PATTERN);
    return match ? decodeColor(match[1]) : '';
  }

  function selectedColor(picker) {
    const colorFieldset = Array.from(picker.querySelectorAll('fieldset')).find(
      (fieldset) => normalize(fieldset.querySelector('legend')?.textContent) === 'color'
    );
    if (!colorFieldset) return '';
    return (
      colorFieldset.querySelector('input:checked')?.value ||
      colorFieldset.querySelector('select')?.value ||
      ''
    );
  }

  function mediaOwner(image) {
    return image.closest('.product-media-container, .dialog-thumbnails-list__thumbnail');
  }

  function filterGallery(picker) {
    const color = normalize(selectedColor(picker));
    const productArea = picker.closest('product-information, featured-product-information, quick-add-dialog') || document;
    const gallery = productArea.querySelector('media-gallery');
    if (!gallery) return;

    const changedOwners = new Set();
    gallery.querySelectorAll('img').forEach((image) => {
      const owner = mediaOwner(image);
      if (!owner || changedOwners.has(owner)) return;
      changedOwners.add(owner);

      const assignedColor = normalize(imageColor(image));
      const hidden = Boolean(color && assignedColor && assignedColor !== color);
      if (hidden) {
        owner.classList.add(HIDDEN_CLASS);
        owner.setAttribute('hidden', '');
      } else {
        owner.classList.remove(HIDDEN_CLASS);
        owner.removeAttribute('hidden');
      }
      owner.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    });

    window.dispatchEvent(new Event('resize'));
  }

  function applyAll() {
    document.querySelectorAll('variant-picker').forEach(filterGallery);
  }

  let pending;
  function scheduleApply() {
    window.clearTimeout(pending);
    pending = window.setTimeout(applyAll, 30);
  }

  document.addEventListener('variant:selected', (event) => {
    const picker = event.target.closest?.('variant-picker');
    if (picker) window.requestAnimationFrame(() => filterGallery(picker));
    scheduleApply();
  });
  document.addEventListener('shopify:section:load', scheduleApply);
  new MutationObserver(scheduleApply).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll, { once: true });
  } else {
    applyAll();
  }
})();
